/** UTC 日期工具：日课用今日，练习固定 T-1（昨天）。 */

export function utcDateString(d: Date): string {
  return d.toISOString().slice(0, 10);
}

export function todayUTC(now: Date = new Date()): string {
  return utcDateString(now);
}

/** T-1：练习模式永远使用昨天的种子，禁止用当日种子练习。 */
export function yesterdayUTC(now: Date = new Date()): string {
  return shiftDate(todayUTC(now), -1);
}

/** UTC 日期串平移 n 天。 */
export function shiftDate(date: string, n: number): string {
  const d = new Date(`${date}T00:00:00.000Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return utcDateString(d);
}
